module.exports = __webpack_public_path__ + "assets/img/xxgz_logo.579be29c.png";